import React, { useState, useEffect, useContext, useMemo } from 'react';
// import './index.css';
import AuthContext from '../../../../contexts/auth';
import { getClientDomain, verifyHideCountryItems } from '../../../../utils/Common';

// components
import StatusPlatforms from '../AdminStats/StatusPlatforms';
import MostUsedPlatform from '../AdminStats/MostUsedPlatform';
import PackagesPickUpLastYear from '../AdminStats/PackagesPickUpLastYear';
import PackagesExpired from './PackagesExpired';
import PackagesWaitingDelivery from './PackagesWaitingDelivery';
import PackagesInPlatforms from './PackagesInPlatforms';
import GraphPackagesPickUpByPlatform from './GraphPackagesPickUpByPlatform';
import GraphPackagesInPlatforms from './GraphPackagesInPlatforms';
import GraphPackagesReturnedByPlatform from './GraphPackagesReturnedByPlatform';
import PackagesReturnedLastYear from '../AdminStats/PackagesReturnedLastYear';
import { Card } from '@/components/ui/card';
import LatestTransactions from '../components/LatestTransactions';

const UserHome = () => {
  const UserContext = useContext(AuthContext);

  const [statusPlatforms, setStatusPlatforms] = useState(null);
  const [cantPackagesInLocker, setCantPackagesInLocker] = useState(null);
  const [cantPackagesExpired, setCantPackagesExpired] = useState(null);
  const [cantPackagesDelivery, setCantPackagesDelivery] = useState(null);
  const [cantPackagesPickUp, setCantPackagesPickUp] = useState(null);
  const [cantPackagesPickUpLastYear, setCantPackagesPickUpLastYear] = useState(null);

 const mergedDataPlatforms = useMemo(() => {
   if (!statusPlatforms && !cantPackagesInLocker) return [];
 
   const merged = {};
 
   const normalizePlatform = (item) => {
     const id = item.IdPlataforma ?? item.id;
     return {
       ...item,
       IdPlataforma: id,
     };
   };
 
   // Agrega primero las plataformas con estado
   (statusPlatforms || []).forEach(p => {
     const platform = normalizePlatform(p);
     merged[platform.IdPlataforma] = { ...platform, CantPaquetes: 0 };
   });
 
   // Completa o agrega las plataformas con paquetes
   (cantPackagesInLocker || []).forEach(l => {
     const locker = normalizePlatform(l);
     const id = locker.IdPlataforma ?? locker.id;
 
     merged[id] = {
       ...(merged[id] || {
         Plataforma: locker.Plataforma,
         Estatus: locker.Estatus || 'OFFLINE',
         LastConnection: '',
         IdPlataforma: id,
       }),
       CantPaquetes: locker.CantPaquetes,
       CantPaquetesReservados: locker.CantPaquetesReservados || 0,
       CantPaquetesColectar: locker.CantPaquetesColectar || 0,
       CantPaquetesVencidos: locker.CantPaquetesVencidos || 0,
     };
   });
 
   return Object.values(merged);
 }, [statusPlatforms, cantPackagesInLocker]);

  useEffect(() => {
    const controller = new AbortController();
    const getDashboardInfo = async () => {
      const showStatsModule = UserContext.user?.roleId < 4 && (UserContext.user?.RoleBli == null || UserContext.user?.RoleBli < 4);
      if (showStatsModule) {
        try {
          const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/expired/user/${UserContext.user?.Ruc}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            signal: controller.signal
          });

          const result = await response.json();
          if (result) {
            if (result.payload) {
              if (result.payload.length > 0) {
                setCantPackagesExpired(result.payload[0].CantPaquetesVencidos);
              }
              else {
                setCantPackagesExpired(0);
              }
            }
            else {
              setCantPackagesExpired(0);
            }
          }
        } catch (error) {
          console.log('error:', error);
        }
        try {
          const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/awaitingDelivery/user/${UserContext.user?.Ruc}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
          });

          const result = await response.json();
          if (result) {
            if (result.payload) {
              if (result.payload[0]) {
                setCantPackagesDelivery(result.payload[0].CantPaquetesEntrega);
              }
              else {
                setCantPackagesDelivery(0);
              }
            }
            else {
              setCantPackagesDelivery(0);
            }
          }
        } catch (error) {
          console.log('error:', error);
        }
      }

      try {
        let dataToSend = {};
        dataToSend.mes = new Date().getMonth() + 1;
        dataToSend.ano = new Date().getFullYear();

        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/pickUpXMonth/user/${UserContext.user?.Ruc}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${sessionStorage.getItem('token')}`
          },
          body: JSON.stringify(dataToSend)
        });

        const result = await response.json();
        if (result) {
          if (result.code === 200) {
            if (result.payload) {
              if (result.payload.length > 0) {
                setCantPackagesPickUp(result.payload);
              }
              else {
                setCantPackagesPickUp([]);
              }
            }
          }
          else {
            setCantPackagesPickUp([]);
          }
        }
      } catch (error) {
        console.log('error:', error);
      }

      if (UserContext.user?.IdTipoUsuario !== 1) {
        try {
          let dataToSend = {};
          dataToSend.ano = new Date().getFullYear();
          const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/pickUpLastYear/user/${UserContext.user?.Ruc}`, {
            method: 'POST',
            accept: 'application/json',
            headers: {
              'Content-Type': 'application/json',
              'authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: JSON.stringify(dataToSend)
          });

          const result = await response.json();
          if (result) {
            if (result.payload) {
              let cantPaquetes = 0;

              if (result.payload?.length > 0) {
                result.payload?.map(plataforma => cantPaquetes += plataforma.value);
                setCantPackagesPickUpLastYear(cantPaquetes)
              }
              else setCantPackagesPickUpLastYear(0);
            }
            else setCantPackagesPickUpLastYear(0);
          }
        } catch (error) {
          console.log('error:', error);
        }
      }
      try {
        const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/packagesInLockers/user/${UserContext.user?.Ruc}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${sessionStorage.getItem('token')}`
          },
          signal: controller.signal
        });

        const result = await response.json();
        if (result) {
          if (result.payload) {
            if (result.payload?.length > 0) {
              setCantPackagesInLocker(result.payload);
            }
            else setCantPackagesInLocker([]);
          }
          else setCantPackagesInLocker([]);
        }
      } catch (error) {
        console.log('error:', error);
      }
      if (UserContext.user?.IdTipoUsuario !== 1) {
        try {
          const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/status/client/${UserContext.user?.IdCliente}`, {
            method: 'GET',
            accept: 'application/json',
            headers: {
              'Content-Type': 'application/json',
              'authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            signal: controller.signal
          });

          const result = await response.json();
          if (result) {
            if (result.payload) {
              if (result.payload.length > 0) {
                setStatusPlatforms(result.payload);
              }
              else {
                setStatusPlatforms([]);
              }
            }
          }
        } catch (error) {
          console.log('error:', error);
        }
      }
    }

    getDashboardInfo();
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showStatsModule = UserContext.user?.roleId < 4 && (UserContext.user?.RoleBli == null || UserContext.user?.RoleBli < 4);

  const isProvider = UserContext.user?.IdTipoUsuario === 1;
  const showReturns = verifyHideCountryItems(["us", "pa"]);

  // One card, one figure. Same shape as AdminStats.
  const StatCard = ({ children, className }) => (
    <Card className={`flex min-h-[8rem] flex-col items-center justify-center p-4 ${className || ''}`}>
      {children}
    </Card>
  );

  return (
    <div className="space-y-4">
      {showStatsModule && (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-4">
          <StatCard className="lg:col-span-2">
            <GraphPackagesInPlatforms cantPackagesInLocker={cantPackagesInLocker} />
          </StatCard>

          <StatCard>
            <PackagesExpired cantPackagesExpired={cantPackagesExpired} />
          </StatCard>

          <StatCard>
            <PackagesWaitingDelivery cantPackagesDelivery={cantPackagesDelivery} />
          </StatCard>
        </div>
      )}

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className={`grid gap-4 ${isProvider ? 'lg:col-span-2' : 'lg:col-span-2'} ${showReturns ? 'sm:grid-cols-2' : ''}`}>
          <StatCard>
            <GraphPackagesPickUpByPlatform cantPackagesPickUp={cantPackagesPickUp} />
          </StatCard>

          {showReturns && (
            <StatCard>
              <GraphPackagesReturnedByPlatform />
            </StatCard>
          )}
        </div>

        {!isProvider ? (
          <div className="grid gap-4">
            <StatCard>
              <MostUsedPlatform cantPackagesPickUp={cantPackagesPickUp} />
            </StatCard>

            <div className={`grid gap-4 ${showReturns ? 'sm:grid-cols-2' : ''}`}>
              <StatCard>
                <PackagesPickUpLastYear cantPackagesPickUpLastYear={cantPackagesPickUpLastYear} />
              </StatCard>

              {showReturns && (
                <StatCard>
                  <PackagesReturnedLastYear />
                </StatCard>
              )}
            </div>
          </div>
        ) : (
          <StatCard>
            <PackagesInPlatforms cantPackagesInLocker={cantPackagesInLocker} />
          </StatCard>
        )}
      </div>

      {!isProvider && (
        <StatusPlatforms
          statusPlatforms={statusPlatforms && cantPackagesInLocker ? mergedDataPlatforms : null}
        />
      )}

      <LatestTransactions />
    </div>
  );
}


export default UserHome;